export default "__VITE_ASSET__4b1ce25a__"